export default __webpack_public_path__ + "static/media/text_image.8d0d21aa.jpg";